module.exports = __webpack_public_path__ + "img/gift4-01-c09-y2.962cf6bb.png";